/* -------------------------------------------------------------------------- */
/*                            External Dependencies                           */
/* -------------------------------------------------------------------------- */
import React from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Link } from 'react-router-dom';

/* -------------------------- Internal Dependencies ------------------------- */
import { forgotPassword } from 'redux/user/actions';
import { selectisLoading } from 'redux/user/selector';
import { forgotValdationSchema } from 'utils/validation-schema';
import Input from 'components/input';
import Button from 'components/button';
import AuthLayout, {
	AuthStylingLayoutChildren,
} from '../../components/layout/auth-layout';
import SEO from 'components/seo';

/* ---------------------------- Forgot propTypes ---------------------------- */
const propTypes = {
	isLoading: PropTypes.bool,
	forgotPassword: PropTypes.func,
};

const Forgot = ({ forgotPassword: forgot, isLoading }) => {
	return (
		<AuthLayout>
			<SEO title="Reset password" />
			<AuthStylingLayoutChildren>
				<h3>Reset password</h3>
				<p className="intro__text">
					Enter your email address to get reset link
				</p>
				<Formik
					initialValues={{
						email: '',
					}}
					validationSchema={forgotValdationSchema}
					onSubmit={async ({ email }) => {
						await forgot?.({ email });
					}}
				>
					{({
						values,
						errors,
						touched,
						handleChange,
						handleBlur,
						handleSubmit,
					}) => (
						<form onSubmit={handleSubmit}>
							<Input
								hasStrip
								id="email"
								name="email"
								type="email"
								label="Email Address"
								placeholder="Email Address"
								value={values.email}
								onChange={handleChange}
								onBlur={handleBlur}
								errorMessage={errors.email}
								isInvalid={errors.email && touched.email}
							/>
							<Button
								type="submit"
								className="btn-developp btn-block"
								isLoading={isLoading}
								disabled={isLoading}
							>
								Get password reset link
							</Button>
						</form>
					)}
				</Formik>
				<p className="intro__link-link-out">
					Remember Password? <Link to="/">Login</Link>
				</p>
			</AuthStylingLayoutChildren>
		</AuthLayout>
	);
};

Forgot.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
	isLoading: selectisLoading,
});

export default connect(mapStateToProps, { forgotPassword })(Forgot);
